export const FETCH_JOKE_PENDING = 'FETCH_JOKE_PENDING'
export const FETCH_JOKE_SUCCESS = 'FETCH_JOKE_SUCCESS'
export const FETCH_JOKE_FAILED = 'FETCH_JOKE_FAILED'
